import { Component, OnInit } from '@angular/core';
import {
  ConnectionPointDto,
  ConversionFactorsService,
  MeterConversionFactor,
  MeterDto,
  MeterFrameConversionFactor,
  MeterFrameDto,
  MeterFrameHistoricalDto,
  MeterFrameService,
  MeterService as NtsMeterService
} from '@app/api/nts';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { TabsComponent } from '@shared/components/tabs/tabs.component';
import { TabComponent } from '@shared/components/tabs/tab/tab.component';
import { Columns } from '@shared/interfaces/table/column-config';
import { meterframeDetailsMasterdata } from '@shared/interfaces/nts/Meterframes/meterframe-details.masterdata';
import { ValueDetailsComponent } from '@app/shared/components/value-details/value-details.component';
import {
  AuthRoles,
  MeteringPointQueryResultCollectionDto,
  MeteringPointQueryResultDto,
  MeteringPointService,
  MeterService as DmcMeterService,
  QueryMeterDeviationLimitsDto
} from '@app/api/dmc';
import { meterInformationMasterData } from '@shared/interfaces/nts/Meter/meter-information.masterdata';
import { meterProductMasterData } from '@shared/interfaces/nts/Meter/meter-product.masterdata';
import { meterQuadrantMasterData } from '@shared/interfaces/nts/Meter/meter-quadrant.masterdata';
import { TableConfig } from '@shared/interfaces/table/table-config';
import { meterframeOverviewActionMenu } from '@views/meterframes/meterframe-overview/meterframe-overview.action-menu';
import { HeaderService } from '@app/core/services/header.service';
import { ModalService } from '@app/core/services/modal.service';
import { meterframeHistoryTable } from '@shared/table-configs/meterframe/meterframe-history.table';
import {
  meterConversionFactorTable,
  meterframeConversionFactorTable
} from '@shared/table-configs/meterframe/meterframe-conversion-factor.table';
import { TableComponent } from '@shared/components/table/table.component';
import { TranslatePipe } from '@ngx-translate/core';
import { CardComponent } from '@shared/components/card/card.component';
import { meterFrameColumns } from '@views/meterframes/meterframe-overview/meterframe.columns';
import { FlattenedMeterFrameHistoricalDto } from '@shared/interfaces/dto/FlattenedMeterFrameHistoricalDto';
import { TableCellComponent } from '@shared/components/table/table-cell/table-cell.component';
import {
  meterFrameOpenformModalConfig
} from '@shared/modals/meterframe/meterframe-openform/meterframe-openform.modal-config';
import { meterframeCloseModalConfig } from '@shared/modals/meterframe/meterframe-close/meterframe-close.modal-config';
import { meterOpenFormModalConfig } from '@shared/modals/meter/meter-openform/meter-openform.modal-config';
import {
  meterOpenFormWithoutAttachModalConfig
} from '@shared/modals/meter/meter-openform/meter-openform-without-attach.modal-config';
import { meterOpenformEditModalConfig } from '@shared/modals/meter/meter-openform/meter-openform-edit.modal-config';
import { meterRemoveModalConfig } from '@shared/modals/meter/meter-remove/meter-remove.modal-config';
import {
  meterframeOpenformEditModalConfig
} from '@shared/modals/meterframe/meterframe-openform/meterframe-openform-edit.modal-config';
import {
  meterframeAddConversionFactorModalConfig
} from '@shared/modals/meterframe/meterframe-add-conversion-factor/meterframe-add-conversion-factor.modal-config';
import {
  meterAddQuadrantMappingModalConfig
} from '@shared/modals/meter/meter-add-quadrant-mapping/meter-add-quadrant-mapping.modal-config';
import {
  meteringPointDirectRelationTable
} from '@shared/table-configs/meteringpoint/meteringpoint-direct-relation.table';
import { meterFrameSerialMasterdata } from '@shared/interfaces/nts/Meterframes/meterframe-serial.masterdata';
import { meterFrameParallelMasterdata } from '@shared/interfaces/nts/Meterframes/meterframe-parallel.masterdata';
import { StateManagerService } from '@shared/state/state-manager.service';
import {
  meterReplaceAttachModalConfig
} from '@shared/modals/meter/meter-replace-attach-modal/meter-replace-attach.modal-config';
import { TransferClickService } from '@app/core/services/transfer-click.service';
import { TimeseriesGraphConfig } from '@shared/components/timeseries-graph/timeseries-graph-config';
import { TimeseriesGraphService } from '@shared/components/timeseries-graph/timeseries-graph.service';
import { TimeSeriesData } from '@shared/components/timeseries-graph/timeseries-data.interface';
import { meterReplaceModalConfig } from '@shared/modals/meter/meter-replace-modal/meter-replace-modal-config';
import { conversionFactorMasterdata } from '@shared/interfaces/nts/Meter/conversion-factor.masterdata';
import { hasRole } from '@app/core/guards/has-role.guard';

@Component({
  selector: 'app-meterframe-overview',
  imports: [
    TabsComponent,
    TabComponent,
    ValueDetailsComponent,
    TableComponent,
    TranslatePipe,
    CardComponent,
    TableCellComponent,
  ],
  templateUrl: './meterframe-overview.component.html',
  styleUrl: './meterframe-overview.component.css'
})
export class MeterframeOverviewComponent implements OnInit {
  public currentActiveTab: number = 0;
  public meterFrames: MeterFrameDto[] = [];
  public id!: string;
  public selectedElements: FlattenedMeterFrameHistoricalDto[] = [];
  public meterFrameHistory: Map<string, FlattenedMeterFrameHistoricalDto[]> = new Map<string, FlattenedMeterFrameHistoricalDto[]>();

  /** Connection Point **/
  public connectionPoint?: ConnectionPointDto;

  /** Data Columns **/
  public meterFramePrimaryMasterData: Columns<MeterFrameDto>[] = meterframeDetailsMasterdata;
  public meterFrameStationMasterData: Columns<MeterFrameDto>[] = meterframeDetailsMasterdata;
  public meterFrameSerialMasterData: Columns<MeterFrameDto>[] = meterFrameSerialMasterdata;
  public meterFrameParallelMasterData: Columns<MeterFrameDto>[] = meterFrameParallelMasterdata;
  public meterInformationMasterData: Columns<MeterDto>[] = meterInformationMasterData;
  public meterProductMasterData: Columns<MeterDto>[] = meterProductMasterData;
  public meterQuadrantMasterData: Columns<MeterDto>[] = meterQuadrantMasterData;
  public meterConversionFactorMasterData: Columns<MeterDto>[] = conversionFactorMasterdata;

  public meterFrameMeter: Map<string, MeterDto> = new Map<string, MeterDto>();
  public meterMeteringPoint: Map<string, MeteringPointQueryResultDto[]> = new Map<string, MeteringPointQueryResultDto[]>();

  /** Table configuration for metering point direct relation table. */
  public meteringPointDirectRelationConfig: TableConfig<MeteringPointQueryResultDto> = {
    ...meteringPointDirectRelationTable,
    refreshable: true,
    refresh: () => this.refreshAll(),
  }

  public readonly meterFrameHistoryTableConfig: TableConfig<FlattenedMeterFrameHistoricalDto> = {
    ...meterframeHistoryTable,
    refreshable: true,
    refresh: () => this.refreshAll(),
  };

  public dataColumns = meterFrameColumns;

  /** Conversion factor table configs **/
  public readonly meterframeConversionFactorTableConfig: TableConfig<MeterFrameConversionFactor> = {
    ...meterframeConversionFactorTable,
    refreshable: true,
    refresh: () => this.refreshAll(),
  };
  public readonly meterConversionFactorTableConfig: TableConfig<MeterConversionFactor> = {
    ...meterConversionFactorTable,
    refreshable: true,
    refresh: () => this.refreshAll(),
  };

  /** Conversion factor data — keyed by frame ID **/
  public meterFrameConversionFactors: Map<string, MeterFrameConversionFactor[]> = new Map();
  public meterConversionFactors: Map<string, MeterConversionFactor[]> = new Map();

  /** Tracks which frames have their conversion factor section expanded **/
  public openConversionFactors = new Set<string>();

  /** Whether the data has been fetched from the API. */
  public dataFetched = false;

  constructor(
    private readonly headerMenuService: HeaderService,
    private readonly meterFrameService: MeterFrameService,
    private readonly ntsMeterService: NtsMeterService,
    private readonly dmcMeterService: DmcMeterService,
    private readonly meteringPointService: MeteringPointService,
    private readonly conversionFactorsService: ConversionFactorsService,
    private readonly modalService: ModalService,
    private readonly route: ActivatedRoute,
    private readonly stateService: StateManagerService,
    private readonly transferClickService: TransferClickService,
  ) {
    const cpWriter = hasRole([AuthRoles.ConnectionPointWriter]);

    this.route.parent?.paramMap.subscribe((q: ParamMap) => {
      this.id = q.get('id')!;

      this.headerMenuService.setActions(meterframeOverviewActionMenu, {
          createMeterFrame: () => this.openMeterFrameFormModal(),
          editMeterFrame: () => this.openMeterFrameEditModal(),
          closeMeterFrame: () => this.openMeterFrameCloseModal(),
          createMeter: () => this.openMeterFormModal(),
          addMeterWithoutAttaching: () => this.openMeterCreateWithoutAttachFormModal(),
          attachMeter: () => this.openAttachMeterModal(),
          editMeter: () => this.openMeterFormEditModal(),
          removeMeter: () => this.openRemoveMeterModal(),
          replaceMeter: () => this.openReplaceMeterModal(),
          addConversionFactor: () => this.openAddConversionFactorModal(),
          changeQuadrantMapping: () => this.openChangeQuadrantMappingModal(),
        },
        {
          createMeterFrame: () => !cpWriter || this.connectionPoint?.state === 'Inactive',
          editMeterFrame: () => !cpWriter || !this.currentMeterFrame,
          closeMeterFrame: () => !cpWriter || this.currentMeterFrame?.status !== 'Active',
          createMeter: () => !cpWriter || !this.currentMeterFrame || !!this.meterFrameMeter.get(this.currentMeterFrame.id!),
          addMeterWithoutAttaching: () => !cpWriter || false,
          attachMeter: () => !cpWriter || !this.currentMeterFrame || !!this.meterFrameMeter.get(this.currentMeterFrame.id!),
          editMeter: () => !cpWriter || !this.currentMeterFrame || !this.meterFrameMeter.get(this.currentMeterFrame.id!),
          removeMeter: () => !cpWriter || !this.currentMeterFrame || !this.meterFrameMeter.get(this.currentMeterFrame.id!),
          replaceMeter: () => !cpWriter || !this.currentMeterFrame || !this.meterFrameMeter.get(this.currentMeterFrame.id!),
          addConversionFactor: () => !cpWriter || this.currentMeterFrame?.status !== 'Active',
          changeQuadrantMapping: () => !cpWriter || !this.currentMeterFrame?.id || !this.meterFrameMeter.get(this.currentMeterFrame.id),
        });

      this.stateService.getConnectionPoint(this.id).subscribe(
        (cp: ConnectionPointDto) => {
          this.connectionPoint = cp;
        }
      )

      // Initial Fetch
      this.fetchMeterFrames();
    })

    this.transferClickService.click$.subscribe((event: any) => {
      if (event.area === 'meterframe' && event.value && this.meterFrames.length > 0) {
        const tab = this.meterFrames.find(frame => frame.id === event.value);
        if (tab) {
          this.currentActiveTab = this.meterFrames.indexOf(tab);
        }
      }
    })
  }

  public ngOnInit(): void {

  }

  /**
   * Refreshes every dataset rendered on this view. The per-frame history,
   * meter, and conversion factor fetches all cascade from `fetchMeterFrames`,
   * so calling that is enough to re-pull everything.
   */
  public refreshAll(): void {
    this.fetchMeterFrames();
  }

  private fetchMeterFrames(): void {
    if (this.id) {
      this.meterFrameService.meterFrameFromconnectionpointGet(this.id).subscribe((frames: MeterFrameDto[]) => {
        // Ensure that the data is fetched
        this.dataFetched = frames.length === 0;

        // Sort frames by priority
        frames.sort((a, b) => (a.priority ?? 0) > (b.priority ?? 0) ? 1 : -1);
        this.meterFrames = frames;

        // Fetch meters for each frame
        this.meterFrames.forEach(frame => {
          if (!frame.id) return;

          // Fetch history for each frame
          this.fetchHistory(frame.id);
          this.fetchMeterFromFrame(frame.id);
          this.fetchMeterFrameConversionFactors(frame.id);
        })
      })
    }
  }

  public fetchMeterFromFrame(id: string): void {
    this.ntsMeterService.meterGetbymeterframeGet(id).subscribe((meter: MeterDto) => {
      if (meter) {
        // Fetch meter deviation limits
        this.fetchMeterDeviationLimits(meter);

        // Set Meter
        this.meterFrameMeter.set(id, meter);

        if (meter.id) {
          this.fetchMeteringPoint(id, meter.id);
          this.fetchMeterConversionFactors(id, meter.id);
        }
      } else {
        this.meterFrameMeter.delete(id);
      }
    })
  }

  public fetchMeterDeviationLimits(meter: MeterDto): void {
    this.dmcMeterService.meterGetMeterDeviationLimitsPost(meter.id).subscribe((deviationLimits: QueryMeterDeviationLimitsDto) => {
      if (deviationLimits) {
        if (meter) {
          meter.verificationMeter = deviationLimits.verificationMeter;
          meter.quadrant = deviationLimits.quadrant;
          meter.relativeDeviation = deviationLimits.relativeDeviation;
          meter.absoluteDeviation = deviationLimits.absoluteDeviation;
        }

        if (meter.id != null) {
          this.meterFrameMeter.set(meter.id, meter);
        }
      }
    })
  }

  private fetchMeteringPoint(frameId: string, meterId: string): void {
    this.meteringPointService.meteringPointQueryPost({ meterId }).subscribe((result: MeteringPointQueryResultCollectionDto) => {
      if (result.results && result.results.length > 0) {
        this.meterMeteringPoint.set(frameId, result.results);
      }
    })
  }

  private fetchHistory(frameId: string): void {
    this.meterFrameService.meterFrameGethistoricalGet(frameId).subscribe((history: MeterFrameHistoricalDto[]) => {
      if (!history) return;
      const flattenedData = this.flattenMeterFrameHistoricalData(history ?? []);
      const sortedData = (flattenedData ?? []).sort((a, b) => a.index! - b.index!);
      this.meterFrameHistory.set(frameId, sortedData);
    })
  }

  get currentMeterFrame(): MeterFrameDto | undefined {
    if (this.meterFrames && this.meterFrames.length > this.currentActiveTab) {
      return this.meterFrames[this.currentActiveTab];
    }
    return undefined;
  }

  private flattenMeterFrameHistoricalData(data: MeterFrameHistoricalDto[]): FlattenedMeterFrameHistoricalDto[] {
    return data.map(item => {
      return {
        // Basic properties
        priority: item.priority,
        identification: item.identification,
        connectionDate: item.connectionDate,
        maximumCurrent: item.maximumCurrent,
        maximumPower: item.maximumPower,
        description: item.description,
        connectionPointId: item.connectionPointId,
        connectionPointIdentification: item.connectionPointIdentification,
        transformer: item.transformer,
        meterFrameType: item.meterFrameType,
        unitType: item.unitType,
        primaryMeterFrameId: item.primaryMeterFrameId,
        primaryMeterFrameIdentification: item.primaryMeterFrameIdentification,
        limitedGridAccess: item.limitedGridAccess,
        capacity: item.capacity,
        status: item.status,
        networkPlacement: item.networkPlacement,
        date: item.date,
        changeBy: item.changeBy,
        meterFrameAction: item.meterFrameAction,
        meterAction: item.meterAction,
        index: item.index,
        conversionFactorA14: item.conversionFactorA14,
        conversionFactorA23: item.conversionFactorA23,
        conversionFactorR12: item.conversionFactorR12,
        conversionFactorR34: item.conversionFactorR34,
        // Flattened properties from meterModel
        meterNumber: item.meterModel?.meterNumber,
        alternateMeterNumber: item.meterModel?.alternateMeterNumber,
        meterSerialNumber: item.meterModel?.serialNumber,
        meterCommissioningDate: item.meterModel?.commissioningDate,
        meterStatus: item.meterModel?.status,
        meterConversionFactorA14: item.meterModel?.conversionFactorA14,
        meterConversionFactorA23: item.meterModel?.conversionFactorA23,
        meterConversionFactorR12: item.meterModel?.conversionFactorR12,
        meterConversionFactorR34: item.meterModel?.conversionFactorR34,
        meterVendorName: item.meterModel?.vendor?.name,
        meterModelName: item.meterModel?.model?.name,
        meterProductionYear: item.meterModel?.productionYear,
        meterNumberOfDigits: item.meterModel?.numberOfDigits,
        meterReadingType: item.meterModel?.meterReadingType,
        acquisitionDate: item.meterModel?.acquisitionDate,
        accuracyClass: item.meterModel?.accuracyClass ?? null,
        comment: item.meterModel?.comment,
        measurementPrinciple: item.meterModel?.measurementPrinciple,
        ctTurnOverRatioDisplayValue: item.meterModel?.ctTurnOverRatioDisplayValue,
        vtTurnOverRatioDisplayValue: item.meterModel?.vtTurnOverRatioDisplayValue
      };
    });
  }

  public toggleConversionFactors(frameId: string): void {
    if (this.openConversionFactors.has(frameId)) {
      this.openConversionFactors.delete(frameId);
    } else {
      this.openConversionFactors.add(frameId);
    }
  }

  private fetchMeterFrameConversionFactors(frameId: string): void {
    this.conversionFactorsService.meterframesIdConversionFactorsGet(frameId).subscribe((factors: MeterFrameConversionFactor[]) => {
      if (factors?.length) {
        this.meterFrameConversionFactors.set(frameId, factors);
      }
    });
  }

  private fetchMeterConversionFactors(frameId: string, meterId: string): void {
    this.conversionFactorsService.metersIdConversionFactorsGet(meterId).subscribe((factors: MeterConversionFactor[]) => {
      if (factors?.length) {
        this.meterConversionFactors.set(frameId, factors);
      }
    });
  }

  /** Modals **/
  public openMeterFrameFormModal(): void {
    this.modalService.show({
      ...meterFrameOpenformModalConfig,
      params: {
        meterFrame: null,
        availableMeterFrames: this.meterFrames,
        connectionPoint: this.connectionPoint,
      }
    }).subscribe(() => {
      this.fetchMeterFrames()
    })
  }

  public openMeterFrameEditModal(): void {
    this.modalService.show({
      ...meterframeOpenformEditModalConfig,
      title: 'connectionPoint.meterFrame.edit',
      params: {
        meterFrame: this.currentMeterFrame,
        availableMeterFrames: this.meterFrames,
        connectionPoint: this.connectionPoint,
      }
    }).subscribe(() => {
      this.fetchMeterFrames()
    })
  }

  public openMeterFrameCloseModal(): void {
    this.modalService.show({
      ...meterframeCloseModalConfig,
      params: {
        id: this.currentMeterFrame?.id
      }
    }).subscribe(() => {
      this.fetchMeterFrames()
    })
  }

  public openMeterFormModal(): void {
    this.modalService.show({
      ...meterOpenFormModalConfig,
      params: {
        currentMeterdto: null,
        meterFrameId: this.currentMeterFrame?.id
      }
    }).subscribe(() => {
      this.fetchMeterFrames()
    })
  }

  public openMeterCreateWithoutAttachFormModal(): void {
    this.modalService.show({
      ...meterOpenFormWithoutAttachModalConfig,
      params: {
        currentMeterdto: null,
        meterFrameId: null
      }
    }).subscribe(() => {
      this.fetchMeterFrames()
    })
  }

  public openMeterFormEditModal(): void {
    const meter = this.meterFrameMeter.get(this.currentMeterFrame?.id!);
    this.modalService.show({
      ...meterOpenformEditModalConfig,
      params: {
        currentMeterdto: meter,
        meterFrameId: this.currentMeterFrame?.id
      }
    }).subscribe(() => {
      this.fetchMeterFrames()
    })
  }

  public openRemoveMeterModal(): void {
    const meterFrame = this.currentMeterFrame;
    const meter = this.meterFrameMeter.get(meterFrame?.id!);
    this.modalService.show({
      ...meterRemoveModalConfig,
      params: { meterDto: meter }
    }).subscribe(() => {
      this.fetchMeterFrames()
    })
  }

  public openAttachMeterModal(): void {
    this.modalService.show({
      ...meterReplaceAttachModalConfig,
      params: {
        meterFrameId: this.currentMeterFrame?.id
      }
    }).subscribe(() => {
      this.fetchMeterFrames()
    })
  }

  public openReplaceMeterModal(): void {
    if (this.currentMeterFrame?.id) {
      this.modalService.show({
        ...meterReplaceModalConfig,
        params: {
          currentMeterFrame: this.currentMeterFrame,
          currentMeter: this.meterFrameMeter.get(this.currentMeterFrame.id),
          meterFrameId: this.currentMeterFrame.id,
        }
      }).subscribe(() => {
        this.fetchMeterFrames()
      })
    }
  }

  public openAddConversionFactorModal(): void {
    const frameId = this.currentMeterFrame?.id;
    if (!frameId) return;

    this.modalService.show({
      ...meterframeAddConversionFactorModalConfig,
      params: {
        meterFrame: this.currentMeterFrame,
        meter: this.meterFrameMeter.get(frameId),
      },
    }).subscribe(() => {
      this.fetchMeterFrameConversionFactors(frameId);
      const meter = this.meterFrameMeter.get(frameId);
      if (meter?.id) {
        this.fetchMeterConversionFactors(frameId, meter.id);
      }
    });
  }

  public openChangeQuadrantMappingModal(): void {
    const frameId = this.currentMeterFrame?.id;
    if (!frameId) return;

    const meter = this.meterFrameMeter.get(frameId);
    if (!meter) return;

    this.modalService.show({
      ...meterAddQuadrantMappingModalConfig,
      params: { meter },
    }).subscribe(() => {
      this.fetchMeterFrames();
    });
  }
}
